<template>
    <div :style="cssStyle" class="d-inline-block">
        <svg version="1.1" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.6 39.6">
            <path fill="currentColor" d="M32.5,28.5c-0.3,0-0.5-0.2-0.5-0.5v-10c0-6.6-5.3-11.9-11.9-11.9S8.2,11.4,8.2,17.9l0,0v10
                c0,0.3-0.3,0.5-0.6,0.5c-0.3,0-0.5-0.2-0.5-0.5v-10C7,10.8,12.8,4.9,19.9,4.9c7.2-0.1,13,5.7,13.1,12.9c0,0.1,0,0.1,0,0.2v10
                C33,28.2,32.8,28.5,32.5,28.5"/>
            <path fill="currentColor" d="M20,39.6c-2.6,0-4.7-2.1-4.7-4.7v-0.8c0-0.3,0.3-0.5,0.6-0.5c0.3,0,0.5,0.2,0.5,0.5v0.8
                c0,2,1.6,3.6,3.6,3.6s3.6-1.6,3.6-3.6v-0.8c0-0.3,0.3-0.5,0.6-0.5c0.3,0,0.5,0.2,0.5,0.5v0.8C24.7,37.5,22.6,39.6,20,39.6"/>
            <path fill="currentColor" d="M23.3,6.5c-0.3,0-0.5-0.2-0.5-0.5V3.9c0-1.5-1.2-2.8-2.8-2.8s-2.8,1.2-2.8,2.8v2.1
                c0,0.3-0.2,0.6-0.5,0.6c-0.3,0-0.5-0.2-0.6-0.5c0,0,0,0,0-0.1V3.8C16.2,1.7,17.9,0,20,0s3.9,1.7,3.9,3.8V6
                C23.9,6.3,23.6,6.5,23.3,6.5"/>
            <path fill="currentColor" d="M31.7,34.8H8c-3.7,0-6.7-3-6.7-6.7c0-0.3,0.2-0.5,0.5-0.5h36.1c0.3,0,0.5,0.2,0.5,0.5
                C38.4,31.7,35.4,34.8,31.7,34.8 M2.3,28.6c0.3,2.9,2.7,5.1,5.6,5.1h23.7c2.9,0,5.3-2.2,5.6-5.1C37.3,28.6,2.3,28.6,2.3,28.6z"/>
            <path fill="currentColor" d="M12,23.9c-0.3,0-0.5-0.2-0.5-0.5v-5.3c0-1.9,1-3.6,2.7-4.5c0.3-0.1,0.6,0,0.7,0.3
                c0.1,0.2,0,0.5-0.2,0.7c-1.3,0.7-2.1,2-2.1,3.5v5.3C12.5,23.7,12.3,23.9,12,23.9"/>
        </svg>
    </div>
</template>
<script type="text/javascript">
    import iconDefault from '@/assets/icons/_default.js';
    export default {...iconDefault};
</script>